module.exports = __webpack_public_path__ + "static/media/contact_support.8c15953d.svg";